<template>
  <div>
    <div class="row q-col-gutter-md q-mb-xm">
      <q-select
        v-model="section.config.posterCarouselType"
        class="col-3"
        label="Type"
        :options="[{ value: 'current', label: 'Current' }, { value: 'upcoming', label: 'Upcoming' }, { value: 'current-and-upcoming', label: 'Current and Upcoming' }]"
        map-options
        emit-value
        bottom-slots
      />
      <q-select
        v-model="section.titleClassIds"
        label="Title Classes"
        map-options
        :options="titleClasses.data"
        clearable
        option-label="name"
        option-value="id"
        emit-value
        class="col-3"
        multiple
        use-chips
      />
      <q-input
        v-model.number="section.config.posterCarouselNumberOfMoviesOnShow"
        class="col-6 col-sm-3"
        label="Displayed Movies Limit"
        type="number"
        min="0"
        max="60"
        step="1"
      >
        <q-tooltip>Leave empty to show all movies.</q-tooltip>
      </q-input>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.showHeading"
          label="Show Heading"
        />
      </div>

      <div
        v-if="section.config.posterCarouselType === 'current-and-upcoming'"
        class="col-3"
      >
        <q-checkbox
          v-model="section.config.posterCarouselShowFilter"
          label="Show Filter Buttons"
        />
      </div>
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Slide Settings
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-xm">
      <div class="col-3">
        <q-checkbox
          v-model="configureMaxSlidesPerView"
          label="Customised Maximun Slides Per View"
        />
      </div>
      <template v-if="configureMaxSlidesPerView">
        <div class="col-3">
          <q-item-label>Maximum Slides Per View</q-item-label>
          <q-slider
            v-model="section.config.posterCarouselMaxSlidesPerView"
            label
            label-always
            switch-label-side
            type="number"
            :min="1.2"
            :max="12.2"
            :step="0.2"
            @update:model-value="changeCount++"
          />
        </div>
        <div class="col-3">
          <q-checkbox
            v-model="configureMobileMaxSlidesPerView"
            label="Set Different Maximum Slides Per Row on Mobile"
          />
        </div>
        <div
          v-if="configureMobileMaxSlidesPerView"
          class="col-3"
        >
          <q-item-label>Maximum Slides Per View</q-item-label>
          <q-slider
            v-model="section.config.posterCarouselMobileMaxSlidesPerView"
            label
            label-always
            switch-label-side
            type="number"
            :min="1.2"
            :max="8.2"
            :step="0.2"
            @update:model-value="changeCount++"
          />
        </div>
      </template>
      <div class="col-3">
        <q-item-label>Spacing (px)</q-item-label>
        <q-slider
          v-model="section.config.spacing"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="30"
          :step="1"
          @update:model-value="changeCount++"
        />
      </div>
      <div class="col-3">
        <q-toggle
          v-model="section.config.posterCarouselPaginationVisible"
          label="Pagination Visible"
        />
      </div>
      <div class="col-3">
        <q-toggle
          v-model="section.config.posterCarouselControlsVisibile"
          label="Controls Visible"
        />
      </div>
      <color-selection
        v-if="section.config.posterCarouselControlsVisibile"
        :color-name="section.config.posterCarouselControlsBackgroundColor"
        :custom-color-hex="section.config.posterCarouselControlsBackgroundColorHex"
        :label="'Control Button Background Color'"
        class="col-6"
        @update:model-value="setBackgroundColor"
      />
      <q-toggle
        v-model="section.config.posterCarouselAutoplay"
        class="col-auto"
        label="Autoplay"
        bottom-slots
        @update:model-value="changeCount++"
      />
      <q-input
        v-if="section.config.posterCarouselAutoplay"
        v-model.number="section.config.posterCarouselDelayInSeconds"
        class="col-3"
        label="Delay (seconds)"
        type="number"
        min="0"
        max="60"
        step="0.5"
        bottom-slots
        @update:model-value="changeCount++"
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Poster Settings
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-xm">
      <div class="col-3">
        <q-checkbox
          v-model="section.config.useBanner"
          label="Use Banner Image"
          @update:model-value="changeCount++"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselShowMovieTitle"
          label="Show Movie Title"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselShowMovieRating"
          label="Show Movie Rating"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselShowMovieGenre"
          label="Show Movie Genre"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselShowUserButtons"
          label="Show User Button"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselShowTrailerButton"
          label="Show Trailer Button"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselShowTitleClass"
          label="Show Movie Class"
        />
      </div>
      <div class="col-3">
        <q-checkbox
          v-model="section.config.posterCarouselCleanImage"
          label="Clean Image"
        />
      </div>

      <div class="col-3">
        <q-item-label>Border Radius (px)</q-item-label>
        <q-slider
          v-model="section.config.borderRadius"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="20"
          :step="1"
        />
      </div>
      <div class="col-3">
        <q-item-label>Shadow</q-item-label>
        <q-slider
          v-model="section.config.shadow"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="10"
          :step="1"
        />
      </div>
    </div>
    <template v-if="section.config.posterCarouselShowMovieTitle || section.config.posterCarouselShowMovieRating || section.config.posterCarouselShowMovieGenre">
      <div
        class="row q-mb-sm q-mt-lg"
      >
        <div class="text-bold">
          Text Settings
        </div>
      </div>
      <div class="row q-col-gutter-md q-mb-xm">
        <q-input
          v-model.number="section.config.posterCarouselFontSize"
          label="Font size"
          type="number"
          suffix="px"
          dense
          outlined
          clearable
          class="col-3"
        />
        <div class="col-3">
          <q-checkbox
            v-model="section.config.posterCarouselTextWraped"
            label="Wrap text"
          />
        </div>
        <div class="col-3">
          <q-checkbox
            v-model="section.config.posterCarouselTextCenter"
            label="Text center"
          />
        </div>
        <div class="col-3">
          <q-checkbox
            v-model="section.config.posterCarouselLightText"
            label="Light Text"
          />
        </div>
      </div>
    </template>
    <preview
      :key="changeCount"
      :section="section"
      class="q-mb-xl"
    />
  </div>
</template>

<script>

import Section from 'src/models/page/Section'
import ColorSelection from 'src/modules/admin/components/ColorSelection'
import Preview from 'src/modules/consumer/components/Preview'

export default {
  name: 'PosterCarouselEditor',
  components: {
    Preview,
    ColorSelection
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  data () {
    return {
      changeCount: 0,
      configureMaxSlidesPerView: !!this.section.config.posterCarouselMaxSlidesPerView && this.section.config.posterCarouselMaxSlidesPerView !== 5.2 && !this.useBanner,
      configureMobileMaxSlidesPerView: !!this.section.config.posterCarouselMobileMaxSlidesPerView && this.section.config.posterCarouselMobileMaxSlidesPerView !== 2.2
    }
  },
  watch: {
    configureMaxSlidesPerView () {
      if (!this.configureMaxSlidesPerView) { this.section.config.posterCarouselMaxSlidesPerView = 5.2 }
    },
    configureExplorePosterMobileMaxPerRow () {
      if (!this.configureMobileMaxSlidesPerView) { this.section.config.posterCarouselMobileMaxSlidesPerView = 2.2 }
    },
    'section.config.useBanner' () {
      if (this.section.config.useBanner) { this.section.config.posterCarouselShowMovieTitle = true }
    },
    'section.config.posterCarouselType' () {
      if (this.section.config.posterCarouselType !== 'current-and-upcoming') { this.section.config.posterCarouselShowFilter = false }
    }
  },
  methods: {
    setBackgroundColor (colorName, customColorHex) {
      this.section.config.posterCarouselControlsBackgroundColor = colorName
      this.section.config.posterCarouselControlsBackgroundColorHex = customColorHex
    }
  },
  configuration: ['titleClasses']
}

</script>

<style lang="scss" scoped>
</style>
